import IconType from './iconType';

export default function TiktokIcon({
  width = 16,
  height = 16,
  color = '#667085',
}: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7514 4.15074V6.44917C13.8819 6.39811 13.0189 6.20327 12.2371 5.83231L12.2372 5.83228L12.2339 5.8308C11.8689 5.66559 11.5258 5.45142 11.1803 5.22559L10.8718 5.02388L10.8709 5.39254C10.8694 6.05626 10.8698 6.71904 10.8703 7.38106C10.8711 8.66299 10.8719 9.94209 10.8585 11.2198C10.8077 12.1149 10.5119 13.0042 9.99351 13.7387L9.99348 13.7387L9.99168 13.7413C9.15552 14.9673 7.70181 15.7671 6.21357 15.792L6.21356 15.7919L6.2055 15.7923C5.29535 15.8443 4.38181 15.5961 3.59998 15.1352C2.30818 14.3735 1.39936 12.9782 1.26599 11.4864C1.25042 11.16 1.24517 10.8365 1.25802 10.5216C1.37439 9.30645 1.9768 8.14334 2.90922 7.35307L2.90923 7.35309L2.91126 7.35132C3.93066 6.4635 5.34255 6.02415 6.68023 6.22159C6.68428 6.73039 6.67563 7.23305 6.66694 7.73862C6.66116 8.07464 6.65535 8.41195 6.65324 8.75319C6.00622 8.61368 5.28951 8.70645 4.72847 9.0949C4.27031 9.39272 3.92444 9.84568 3.74337 10.3565C3.61021 10.6864 3.62371 11.049 3.63507 11.3539C3.63701 11.4059 3.63889 11.4562 3.63996 11.5045L3.64023 11.5166L3.64198 11.5287C3.81386 12.7151 4.94765 13.7188 6.18332 13.6139C6.99848 13.6022 7.7698 13.1309 8.18989 12.4461L8.18999 12.4461L8.19342 12.4401C8.20322 12.4228 8.21343 12.405 8.22392 12.3867C8.33753 12.1887 8.48345 11.9344 8.49274 11.6415C8.54069 10.7669 8.5398 9.89257 8.53892 9.02356C8.53859 8.70218 8.53826 8.38152 8.54041 8.06184L8.54041 8.06091C8.54238 7.09623 8.54191 6.13314 8.54144 5.171C8.54063 3.51581 8.53982 1.86346 8.55147 0.210787C8.98512 0.205565 9.4152 0.204995 9.84584 0.204425C10.1539 0.204016 10.4623 0.203608 10.7726 0.201495C10.8608 1.19753 11.2415 2.20529 11.9855 2.92441C12.7311 3.66346 13.757 4.01511 14.7514 4.15074Z"
        fill={color}
        stroke="white"
        strokeWidth={0.4}
      />
    </svg>
  );
}
